<template>
  <section class="agents">
    <div class="top">
      <div class="f5 text-bold">Agents in {{ neighborhoodName }}</div>
      <button class="btn small secondary" @click="openHotlead">Connect with agent</button>
    </div>
    <div class="grid gap-3 lg-grid-cols-4 md-grid-cols-3 sm-grid-cols-2 xs-grid-cols-1">
      <div v-for="agent in agents" :key="agent.id" class="agent-card flex">
        <img v-if="agent.photoUrl" :src='agent.photoUrl' :alt='`${agent.fullName} Profile`'>
        <img v-else :src="`${glb.cdnUrl}vimages/avatar.svg`" :alt='`${agent.fullName} Profile`'/>
        <div class="info">
          <div class="name text-bold">{{ agent.fullName }}</div>
          <div v-if="!!agent.numTransactions">{{ agent.numTransactions }} Transactions</div>
          <div v-if="!!agent.yearsExperience">{{ agent.yearsExperience }} Years of experience</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'exploreAgents',
    props: {
      neighborhoodName: {
        type: String,
        required: true,
      },
      agents: {
          type: Array,
          required: true,
      },
      openHotlead: {
        type: Function,
        required: true,
      }
    },
    computed: {
      ...mapGetters('glb', ['glb']),
    }
  };
</script>

<style lang="scss">
  @use "~@/common/scss/base/_mixins.scss" as *;
  .agents {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .agent-card {
      align-items: center;
      justify-content: left;
      padding: 1.5rem;
      gap: 1rem;
      border-radius: 0.5rem;
      border: 1px solid #ddd;
      @include f7();

      img {
        border-radius: 50%;
        flex-shrink: 0;
        height: 6rem;
        -o-object-fit: cover;
        object-fit: cover;
        width: 6rem;
      }

      .info {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
      }

      >:not(.name) {
        color: var(--color-7);
      }
    }
  }
</style>